import Flash from '@/components/flash';

interface LayoutProps {
  children: React.ReactNode;
  flash: {
    notice?: string;
    error?: string;
  };
}

export default function ApplicationLayout({ children, flash }: LayoutProps) {
  return (
    <>
      <Flash {...flash} />
      <main>{children}</main>
    </>
  );
}
